const STORAGE_PREFIX = 'parkDataStatus:';

const PARK_SLUG_ALIASES = {
  'disneyland-park': 'disneyland-paris',
  'disneyland-paris': 'disneyland-paris',
  'disney-adventure-world': 'walt-disney-studios',
  'walt-disney-studios': 'walt-disney-studios',
  'plopsaland-belgium': 'plopsaland-de-panne',
  'plopsaland-depanne': 'plopsaland-de-panne',
  'plopsaland-de-panne': 'plopsaland-de-panne'
};

export const normalizeParkSlug = (parkSlug) => {
  if (!parkSlug || typeof parkSlug !== 'string') {
    return null;
  }

  return PARK_SLUG_ALIASES[parkSlug] || parkSlug;
};

export const getParkDataStatusStorageKey = (parkSlug) => {
  const normalizedParkSlug = normalizeParkSlug(parkSlug);
  return normalizedParkSlug ? `${STORAGE_PREFIX}${normalizedParkSlug}` : null;
};

const getEmbeddedParkDataStatus = (data) => {
  if (data?.dataStatus && typeof data.dataStatus === 'object') {
    return data.dataStatus;
  }

  if (data?._dataStatus && typeof data._dataStatus === 'object') {
    return data._dataStatus;
  }

  if (data?.waitTimes?._dataStatus && typeof data.waitTimes._dataStatus === 'object') {
    return data.waitTimes._dataStatus;
  }

  return {};
};

export const deriveParkDataStatus = (data, fallback = {}) => {
  const baseStatus = getEmbeddedParkDataStatus(data);

  return {
    isStale: baseStatus.isStale === true,
    source: baseStatus.source || fallback.source || 'server',
    lastUpdated: baseStatus.lastUpdated || data?.lastUpdate || fallback.lastUpdated || new Date().toISOString(),
    lastUpdatedLocal: baseStatus.lastUpdatedLocal || fallback.lastUpdatedLocal,
    timezone: baseStatus.timezone || fallback.timezone,
    error: baseStatus.error || fallback.error
  };
};

export const isReliableParkDataStatus = (dataStatus) => {
  if (!dataStatus) {
    return true;
  }

  return dataStatus.isStale !== true
    && dataStatus.source !== 'cache'
    && dataStatus.source !== 'error';
};

export const readParkDataStatus = (parkSlug) => {
  const storageKey = getParkDataStatusStorageKey(parkSlug);
  if (!storageKey) {
    return null;
  }

  try {
    const rawValue = localStorage.getItem(storageKey);
    return rawValue ? JSON.parse(rawValue) : null;
  } catch {
    return null;
  }
};

export const writeParkDataStatus = (parkSlug, dataStatus) => {
  const storageKey = getParkDataStatusStorageKey(parkSlug);
  if (!storageKey || !dataStatus) {
    return null;
  }

  const normalizedDataStatus = {
    ...dataStatus,
    parkSlug: normalizeParkSlug(parkSlug),
    updatedAt: new Date().toISOString()
  };

  try {
    const serializedValue = JSON.stringify(normalizedDataStatus);
    localStorage.setItem(storageKey, serializedValue);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new StorageEvent('storage', {
        key: storageKey,
        newValue: serializedValue,
        storageArea: localStorage
      }));
    }
  } catch {
    return null;
  }

  return normalizedDataStatus;
};

export const clearParkDataStatus = (parkSlug) => {
  const storageKey = getParkDataStatusStorageKey(parkSlug);
  if (!storageKey) {
    return;
  }

  try {
    localStorage.removeItem(storageKey);

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new StorageEvent('storage', {
        key: storageKey,
        newValue: null,
        storageArea: localStorage
      }));
    }
  } catch {
    return;
  }
};
